import React, { useEffect, useState } from "react";
// import ConfirmPasswordModal from "../../confirmPassword/ConfirmPasswordModal";
import { useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import axios from "../../../config/axiosinstance";
import TaskComponent from "../TaskComponent";
import { useDrop } from "react-dnd";
import InfiniteScroll from "react-infinite-scroll-component";
import { useLocation } from "react-router-dom";
import AnimatedLoader from "../../common/Loader/AnimatedLoader";
// import { object } from 'yup'

const Pending = ({
  addTaskSubmit,
  masterUserTask,
  paramsUserId,
  assign_Task,
  passwordMatched,
  setPasswordMatched,
  handleLoad,
  SelfTask,
  myTaskBoard,
  valSearch,
}) => {
  // console.log("<<< pending - masterUserTask >>>", masterUserTask)

  const currentUser = useSelector((state) => state.user.currentUser);
  // console.log("currentUser in myTask :-", currentUser)

  const location = useLocation();
  const [locationPath, setLocationPath] = useState("");

  const [tasks, setTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // const [showPasswordModal, setShowPasswordModal] = useState(false);
  // const closePasswordModal = () => setShowPasswordModal(false);
  const [taskId, setTaskId] = useState("");
  // const [passwordMatched, setPasswordMatched] = useState(Boolean)

  // useEffect(() => {
  //     setPasswordMatched(false)
  // }, [passwordMatched])

  // console.log("<<<< pending - passwordMatched :-", passwordMatched)

  let title = "TO-DO";
  let status = "Pending";
  let bg_color = "#FFF8E0";
  let border_color = "#FFE785";
  let dragBg_color = "#FFF2C7";

  // console.log("<<< pending tasks >>>", tasks)

  // ============ drag and drop
  const [{ isOver }, drop] = useDrop(() => ({
    accept: "task",
    drop: (item) => addItemToSection(item.id, item.taskStatus),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  // console.log("isOver :-",isOver)

  const [isChanged, setIsChanged] = useState(false);

  // console.log("tasks <<< :-", tasks)
  const addItemToSection = (id, taskStatus) => {
    console.log("dropped id is:-", id, taskStatus, status);
    if (
      assign_Task &&
      (taskStatus === "InProgress" || taskStatus === "UnderReview")
    ) {
      toast.error("Operation Doesn't Perform...");
      return;
    }
    if (masterUserTask && taskStatus === "UnderReview") {
      toast.error("Operation Doesn't Perform...");
      return;
    }
    if (myTaskBoard && taskStatus === "UnderReview") {
      toast.error("Operation Doesn't Perform...");
      return;
    }
    if (taskStatus === status) {
      toast.error("Operation Doesn't Perform...");
    } else {
      if (id) {
        setTaskId(id);
        changeTaskStatus(id);
        // setShowPasswordModal(true);
      }
    }
    // changeTaskStatus(id)
  };

  useEffect(() => {
    if (passwordMatched) {
      console.log("password matched");
      // console.log("<<< taskId >>>", taskId)
      changeTaskStatus(taskId);
    }
    // eslint-disable-next-line
  }, [passwordMatched]);

  const changeTaskStatus = async (id) => {
    // console.log("<<<< change task status >>>", id)
    if (id) {
      // update task status
      const body = {
        service_name: SelfTask
          ? "myself_task_status_change"
          : "task_status_change",
        token: currentUser?.token,
        task_id: id,
        status: status,
      };

      try {
        const resp = await axios.post("/timesheet-web-api", body);
        // console.log("status change resp :-", resp)
        if (resp?.data?.status === 1) {
          setIsChanged(true);
          toast.success(
            `Task ${resp?.data?.task_id} Status Changed Successfully...`
          );
          // fetchTaskList();
          // handleFetchMyTask();
        } else if (resp?.data?.status === 0) {
          setIsChanged(true);
          toast.error(resp?.data?.msg);
        }
      } catch (err) {
        console.log("taskList error :-", err);
      }
    }
    // else{
    //     toast.error(`Error :- Id is ${id}`)
    // }
  };

  const [hasMore, setHasMore] = useState(true);
  const [totalTask, setTotalTask] = useState();

  const page_limit = 10;
  // let pageNo = Number;
  const [pageNo, setPageNo] = useState(1);
  // task_list api

  useEffect(() => {
    // console.log("<<< locationPath >>>", location)
    setLocationPath(location.pathname);
    // console.log("<<< locationPath >>>", locationPath)
    // eslint-disable-next-line
  }, [locationPath]);

  // console.log("<<< locationPath >>>", locationPath)

  const handleFetchMyTask = async (i, x) => {
    if (i) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
    // console.log("<<< pageNo >>>", pageNo)

    if (addTaskSubmit) {
      // pageNo = 1;
      setPageNo(1);
    } else {
      // pageNo = Math.ceil(tasks.length / page_limit) + 1;
      setPageNo(Math.ceil(tasks.length / page_limit) + 1);
    }

    // if (x !== "" && x !== undefined && x !== null) {
    //   pageNo = 1;
    // }

    let body = {};

    if (locationPath && locationPath === "/taskManager/my-task") {
      body = {
        // service_name : 'task_list',
        // token : currentUser?.token,
        // assignee_user_id : currentUser?.User.id,
        // status : 'All'
        service_name: "task_list",
        token: currentUser.token,
        assignee_user_id: currentUser.User.id,
        status: "Pending", //Pending , All
        page: pageNo,
        limit: page_limit,
        search_task_id: x,
      };
    } else if (locationPath && locationPath === "/taskManager/assign-task") {
      body = {
        // service_name: 'assigned_task_list',
        // token: currentUser.token,
        // user_id: currentUser.User.id,
        // task_status: 'All', //Pending
        service_name: "assigned_task_list",
        token: currentUser.token,
        user_id: currentUser.User.id,
        task_status: "Pending", //Pending , All
        page: pageNo,
        limit: page_limit,
        search_task_id: x,
      };
    } else if (masterUserTask) {
      body = {
        service_name: "master_task_list",
        token: currentUser.token,
        task_status: "Pending", //Pending , All
        user_id: paramsUserId,
        page: pageNo,
        limit: page_limit,
        search_task_id: x,
      };
    } else if (SelfTask) {
      body = {
        service_name: "myself_task_list",
        token: currentUser.token,
        assignee_user_id: currentUser.User.id,
        status: "Pending", //Pending , All
        page: pageNo,
        limit: page_limit,
        search_task_id: x,
      };
    }

    if (currentUser) {
      if (Object.keys(body).length !== 0) {
        // console.log("<<< pending body >>>", body)
        try {
          const resp = await axios.post("/timesheet-web-api", body);
          console.log("pending task resp :-", resp?.data?.data);
          if (resp?.data?.status === 1) {
            setTotalTask(resp?.data?.total);
            setIsLoading(false);
            setPageNo((prev) => prev + 1);
            if (x) {
              const mergeData = resp.data?.data;
              setTasks(mergeData);
            } else {
              const mergeData = [...tasks, ...resp.data?.data];
              setTasks(mergeData);
            }
          } else {
            toast.error(`Error :- ${resp?.data?.msg}`);
          }
        } catch (err) {
          setIsLoading(false);
          console.log("taskList error :-", err);
          toast.error(`taskList error :- ${err}`);
        }
      } else {
        setIsLoading(true);
      }
    } else {
      console.log("no users found...");
    }
  };

  const fetchMoreTask = () => {
    console.log("<<< fetch more task  api >>>");
    if (tasks.length !== totalTask) {
      setTimeout(() => {
        // console.log("<<< fetch more task  api >>>")
        handleFetchMyTask(true);
        // console.log("<<< tasks >>>", tasks)
      }, 2000);
    } else {
      setHasMore(false);
    }
  };

  useEffect(() => {
    if (locationPath || locationPath !== undefined || isChanged) {
      handleLoad(isChanged);
      handleFetchMyTask();
      setIsChanged(false);
    }
    // eslint-disable-next-line
  }, [locationPath, isChanged]);

  useEffect(() => {
    if (addTaskSubmit) {
      // console.log("<<< submit assign task >>>", addTaskSubmit)
      handleFetchMyTask();
    }
    // eslint-disable-next-line
  }, [addTaskSubmit]);

  useEffect(() => {
    if (valSearch) {
      handleFetchMyTask(false, valSearch);
      // pageNo = 1;
      setPageNo(1);
    }
    // eslint-disable-next-line
  }, [valSearch]);

  console.log("Current User: ", currentUser?.User.id);

  return (
    <>
      <div
        ref={drop}
        className={tasks.length > 2 ? "task_card" : "task_card height_auto"}
        style={{ backgroundColor: bg_color, borderColor: border_color }}
      >
        <div className="task_header">
          <h4 className="task_title">{title}</h4>
          <span className="task_count">
            {/* {tasks.length} |  */}
            {!totalTask ? 0 : totalTask}
          </span>
        </div>
        {isLoading ? (
          <AnimatedLoader />
        ) : (
          <div
            className="task_body"
            id="parentScrollContainer"
            style={
              tasks.length > 3
                ? { paddingBottom: "0px" }
                : { paddingBottom: "16px" }
            }
          >
            {tasks?.length > 0 ? (
              <InfiniteScroll
                dataLength={tasks.length}
                next={fetchMoreTask}
                hasMore={hasMore}
                loader={<AnimatedLoader />}
                endMessage={
                  <p className="text-center text-dark">Task Finished...</p>
                }
                // height={100}
                scrollableTarget="parentScrollContainer"
              >
                {tasks?.map((task) => {
                  // return <h1 key={task.id}>{task?.Task.id}</h1>
                  return (
                    <TaskComponent
                      key={task?.Task.id}
                      border_color={border_color}
                      dragBg_color={dragBg_color}
                      task={task?.Task}
                      tasks={tasks}
                      setTasks={setTasks}
                      assign_Task={assign_Task}
                      isCurrent={currentUser?.User?.id}
                      pending={true}
                      handleLoad={handleLoad}
                      SelfTask={SelfTask}
                    />
                  );
                })}
              </InfiniteScroll>
            ) : (
              <p className="text-danger text-capitalize">
                {title} - tasks items are not Available
              </p>
            )}

            {isOver && (
              <div
                className="blank_task_box"
                style={{
                  backgroundColor: dragBg_color,
                  borderColor: border_color,
                }}
              >
                <h6 style={{ color: border_color }}>drop here</h6>
              </div>
            )}
          </div>
        )}
      </div>

      {/* {showPasswordModal && (
        <ConfirmPasswordModal
          taskId={taskId}
          closePasswordModal={closePasswordModal}
          passwordMatched={passwordMatched}
          setPasswordMatched={setPasswordMatched}
        />
      )} */}
    </>
  );
};

export default Pending;
